// src/utils/guestsCsv.js

// 出力カラム（必要に応じて増減OK）
const CSV_COLUMNS = [
  "arrangement_id",
  "arrangement_name",
  "arrangement_side",
  "invitee_id",
  "nick_name",
  "first_name",
  "last_name",
  "first_furigana",
  "last_furigana",
  "gender",
  "travel_cost",
  "will",
  "allergy",
  "invited_by",
];

// CSVセルのエスケープ
const csvEscape = (value) => {
  const s = value == null ? "" : String(value);
  if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
};

// 配列→CSV文字列（Excel対策でBOM付き）
const toCSV = (rows, columns = CSV_COLUMNS) => {
  const header = columns.map(csvEscape).join(",");
  const body = rows
    .map((r) => columns.map((c) => csvEscape(r[c])).join(","))
    .join("\n");
  return "\uFEFF" + header + "\n" + body;
};

// ゲスト配列のフィルタ（検索＆参加状況）
const filterGuests = (guests, selectedWill, searchTerm) => {
  const term = (searchTerm || "").toLowerCase();
  return (guests || []).filter((g) => {
    const fullName = `${g.first_name || ""} ${g.first_furigana || ""} ${
      g.last_name || ""
    } ${g.last_furigana || ""} ${g.nick_name || ""}`.toLowerCase();
    const willMatch = selectedWill === "all" || g.will === selectedWill;
    return fullName.includes(term) && willMatch;
  });
};

// 画面の状態に合わせてフラットなレコード配列を構築
const buildRows = ({
  arrangements,
  unarrangedGuests,
  selectedSide,
  selectedWill,
  searchTerm,
}) => {
  const rows = [];

  // sideフィルタ
  const arrangementsFiltered =
    selectedSide === "groom"
      ? arrangements.filter((a) => a.side === "groom")
      : selectedSide === "bride"
      ? arrangements.filter((a) => a.side === "bride")
      : arrangements;

  // 1) テーブルあり
  arrangementsFiltered.forEach((arr) => {
    const guests = filterGuests(arr.guests || [], selectedWill, searchTerm);
    guests.forEach((g) => {
      rows.push({
        arrangement_id: arr.id ?? "",
        arrangement_name: arr.arrangement_name ?? "",
        arrangement_side: arr.side ?? "",
        invitee_id: g.id ?? "",
        nick_name: g.nick_name ?? "",
        first_name: g.first_name ?? "",
        last_name: g.last_name ?? "",
        first_furigana: g.first_furigana ?? "",
        last_furigana: g.last_furigana ?? "",
        gender: g.gender ?? "",
        travel_cost: g.travel_cost ?? "",
        will: g.will ?? "",
        allergy: g.allergy ?? "",
        invited_by: g.invited_by ?? "",
      });
    });
  });

  // 2) 未分類（画面仕様どおり side=all の時だけ）
  if (selectedSide === "all") {
    const guests = filterGuests(
      unarrangedGuests || [],
      selectedWill,
      searchTerm
    );
    guests.forEach((g) => {
      rows.push({
        arrangement_id: "",
        arrangement_name: "テーブル未分類",
        arrangement_side: "N",
        invitee_id: g.id ?? "",
        nick_name: g.nick_name ?? "",
        first_name: g.first_name ?? "",
        last_name: g.last_name ?? "",
        first_furigana: g.first_furigana ?? "",
        last_furigana: g.last_furigana ?? "",
        gender: g.gender ?? "",
        travel_cost: g.travel_cost ?? "",
        will: g.will ?? "",
        allergy: g.allergy ?? "",
        invited_by: g.invited_by ?? "",
      });
    });
  }

  return rows;
};

// ダウンロード実行
const downloadCsv = (csv, prefix = "guests") => {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  const now = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  const yyyy = now.getFullYear();
  const mm = pad(now.getMonth() + 1);
  const dd = pad(now.getDate());
  const hh = pad(now.getHours());
  const mi = pad(now.getMinutes());
  const ss = pad(now.getSeconds());

  a.href = url;
  a.download = `${prefix}_${yyyy}${mm}${dd}_${hh}${mi}${ss}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

/**
 * 公開関数：画面状態を受け取り、CSVを生成して即ダウンロード
 */
export const exportGuestsCSV = ({
  arrangements,
  unarrangedGuests,
  selectedSide,
  selectedWill,
  searchTerm,
  filePrefix = "guests",
}) => {
  const rows = buildRows({
    arrangements,
    unarrangedGuests,
    selectedSide,
    selectedWill,
    searchTerm,
  });
  const csv = toCSV(rows);
  downloadCsv(csv, filePrefix);
};
